import { Link } from "react-router-dom";
import { Shield, Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="relative bg-[#020408] border-t border-white/5">
      <div className="absolute inset-0 bg-gradient-to-t from-blue-950/10 to-transparent pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src="/icono_trace_principal.png" alt="Logo" style={{ height: "50px" }} />
              <span className="font-outfit font-semibold text-lg text-slate-100">
                Trace<span className="text-blue-500">Certificates</span>™
              </span>
            </Link>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              Trace Certificates™ is a brand of the Propensiones Group, operated by the international law firm PROPENSIONES S.A.S., identified with NIT 901.409.813-7 (Colombia).
            </p>
            <div className="flex items-center gap-4">
              <div className="w-8 h-8 rounded-full bg-slate-800/50 border border-slate-700/50 flex items-center justify-center">
                <Mail className="w-3.5 h-3.5 text-slate-400" /> {/* TODO add email link */}
              </div>
              <div className="w-8 h-8 rounded-full bg-slate-800/50 border border-slate-700/50 flex items-center justify-center">
                <MapPin className="w-3.5 h-3.5 text-slate-400" /> {/* TODO add location link */}
              </div>
              <div className="w-8 h-8 rounded-full bg-slate-800/50 border border-slate-700/50 flex items-center justify-center">
                <Phone className="w-3.5 h-3.5 text-slate-400" /> {/* TODO add phone link */}
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit font-semibold text-sm text-slate-200 uppercase tracking-wider mb-6">Services</h4>
            <ul className="space-y-3">
              {[
                { to: "/services/origin-legality", label: "Origin & Legality" },
                { to: "/services/cctt-transfer-traceability", label: "Continuity and Transfer Traceability (CCT-T)" },
                { to: "/services/cnipc-cultural-heritage", label: "Non-Inclusion in Cultural Heritage (CNIPC)" },
                { to: "/services/due-diligence-cdd", label: "Due Diligence Certificate (CDD)" },
                { to: "/services/forensic-instrumental-cefi", label: "Instrumental Forensic Examination Certificate (CEFI)" }
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-slate-500 hover:text-blue-400 text-sm transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-outfit font-semibold text-sm text-slate-200 uppercase tracking-wider mb-6">Company</h4>
            <ul className="space-y-3">
              {["About Us", "Compliance", "Partners", "Careers", "Press"].map((item) => (
                <li key={item}>
                  <span className="text-slate-500 hover:text-blue-400 text-sm transition-colors duration-300 cursor-pointer">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-semibold text-sm text-slate-200 uppercase tracking-wider mb-6">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" />
                <span className="text-slate-400 text-sm">info@tracecertificates.com</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-slate-500 mt-0.5 shrink-0" />
                <span className="text-slate-400 text-sm">Global Operations Center</span>
              </div>
              <Link
                to="/contact"
                data-testid="footer-contact-btn"
                className="inline-block mt-4 text-sm text-blue-400 hover:text-blue-300 font-medium transition-colors"
              >
                Get in Touch &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-xs">
            &copy; {new Date().getFullYear()} Trace Certificates™ & Propensiones Abogados. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-slate-600 text-xs hover:text-slate-400 cursor-pointer transition-colors">Privacy Policy</span>
            <span className="text-slate-600 text-xs hover:text-slate-400 cursor-pointer transition-colors">Terms of Service</span>
            <span className="text-slate-600 text-xs hover:text-slate-400 cursor-pointer transition-colors">Cookie Policy</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
